import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Necesito equipo especial?',
  answer: 'No, solo una silla estable y el espacio que ya tienes en tu sala.'
}, {
  question: '¿Duele hacerlo?',
  answer: 'No. El método trabaja en rangos sin dolor. Si algo duele, te enseñamos a ajustar el movimiento.'
}, {
  question: '¿Es seguro para mi espalda?',
  answer: 'Totalmente. Los movimientos están diseñados para proteger y descomprimir la columna.'
}, {
  question: '¿Puedo leerlo en mi teléfono?',
  answer: 'Sí, el formato PDF es compatible con todos los smartphones, tablets y computadoras.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-cream" data-id="element-37">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-39">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-40">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 border ${isOpen ? 'border-sage shadow-md' : 'border-sage-light/50 shadow-sm'}`} data-id="element-41">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-42">
                  <span className="text-lg font-bold text-sage-dark pr-4" data-id="element-43">
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-sage text-white' : 'bg-sage-light text-sage'}`} data-id="element-44">
                    {isOpen ? <ChevronUp size={20} data-id="element-45" /> : <ChevronDown size={20} data-id="element-46" />}
                  </div>
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-47">
                  <p className="text-text-muted text-lg" data-id="element-48">{faq.answer}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}